import React from 'react'
import styled from 'styled-components'

const Background = styled.div`
  position: fixed;
  ${({ backgroundPosition }) => backgroundPosition && `background-position: ${backgroundPosition}`};
  ${({ backgroundRepeat }) => backgroundRepeat && `background-repeat: ${backgroundRepeat}`}};
  ${({ backgroundSize }) => backgroundSize && `background-size: ${backgroundSize}`}};
  background-image: ${({ backgroundImage, theme }) =>
    backgroundImage ? `url(${backgroundImage})` : `url(${theme.images.darkPatternRotate})`};
  ${({ width }) => width && { width }};
  ${({ height }) => height && { height }};
  ${({ top }) => top && { top }};
  ${({ bottom }) => bottom && { bottom }};
  ${({ right }) => right && { right }};
  ${({ left }) => left && { left }};
  ${({ zIndex }) => zIndex && `z-index: ${zIndex}`}};
`

const FixedBackground = ({
  backgroundPosition = 'center center',
  backgroundImage,
  backgroundRepeat = 'repeat',
  backgroundSize = 'initial',
  left = '0',
  right,
  top = '0',
  bottom,
  height = top !== '0' ? `calc(100% - ${top})` : '100%',
  width = '100%',
  zIndex = '-1',
}) => {
  return (
    <Background
      backgroundImage={backgroundImage}
      backgroundPosition={backgroundPosition}
      backgroundRepeat={backgroundRepeat}
      backgroundSize={backgroundSize}
      bottom={bottom}
      height={height}
      left={left}
      right={right}
      top={top}
      width={width}
      zIndex={zIndex}
    />
  )
}

export default FixedBackground
